import React from 'react';
import { SubTitle, Description, Image, Link } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const IMAGE = buildImageURL('/charging.jpg');
const IMAGE_M = buildImageURL('/charging-m.jpg');

const track = getTrack({ block: 22 });

export function Charging({mobile = false}) {
  return (
    <div className="page-section section-charging inverted" data-track={track}>
      <div className="txt-wrapper">
        <SubTitle>
          一不留神，就充满了
        </SubTitle>
        <Description>
          55W闪充<sup>8</sup>，让你的手机快速回血，畅快生活享不停。
        </Description>
        <Link bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="购买我的X60 Pro+" position={22} />
      </div>
      <Image className="img-wrapper" src={mobile ? IMAGE_M : IMAGE} />

    </div>
  );
}
